import { ReactComponent as ActivityIcon } from "@icons/activity.svg";
import { TrackerProgressCard } from "../../../components/Trackers/TrackerProgressCard";
import { TrackerThresholdPercentages } from "core/state/Trackers/TrackerThresholdPercentages";
import { TrackerType } from "core/state/Trackers/TrackerType";
import { useTrackerContext } from "core/state/TrackerContext/TrackerContext";
import { useTranslation } from "react-i18next";

export const GeneralActivityTrackerProgressCard = () => {
  const { t } = useTranslation();
  const { getGoal, getCurrentTrackerValue } = useTrackerContext();

  const current = getCurrentTrackerValue(TrackerType.Activity);
  const goal = getGoal(TrackerType.Activity);
  const percent = current.percentageOf(goal, 0);

  function getProgressMessage(percentage: number): string {
    switch (true) {
      case percentage >= 100:
        return t(`wellbeing.trackers.progress.complete`);
      case percentage > TrackerThresholdPercentages.High:
        return t("wellbeing.trackers.activity.progress.high", { goal });
      case percentage >= TrackerThresholdPercentages.Medium:
        return t("wellbeing.trackers.activity.progress.medium", { goal });
      default:
        return t("wellbeing.trackers.activity.progress.low", { goal });
    }
  }

  return (
    <TrackerProgressCard
      trackerType={TrackerType.Activity}
      percentage={percent}
      heading={t("wellbeing.trackers.activity.progress.heading")}
      goalHeading={t("wellbeing.trackers.activity.goal.heading")}
      goalDescription={t("wellbeing.trackers.activity.goal.description")}
      goalIncrement={1}
      goalUnit={t("wellbeing.trackers.activity.goal.unit")}
      progressMessage={getProgressMessage(percent)}
      Icon={ActivityIcon}
    />
  );
};
